import { render, staticRenderFns } from "./sourcingmasterTF.vue?vue&type=template&id=5d0bfc6a&scoped=true"
import script from "./sourcingmasterTF.vue?vue&type=script&lang=js"
export * from "./sourcingmasterTF.vue?vue&type=script&lang=js"
import style0 from "./sourcingmasterTF.vue?vue&type=style&index=0&id=5d0bfc6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0bfc6a",
  null
  
)

export default component.exports